import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'work-in-progress',
  templateUrl: './work-in-progress.component.html',
  styleUrls: ['./work-in-progress.component.scss']
})
export class WorkInProgressComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
